import { Component, OnInit, Input, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { BsModalService } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { Subject } from 'rxjs/Subject';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { ExpenseService, CommonService, SubscribeService } from '../../../services/index';
import { ExpenseModal } from '../../../model/index';

import * as fromRootStore from '../../../reducers';
import * as fromCommonStore from '../../../store';

@Component({
    selector: 'add-cash-in-tab',
    templateUrl: './addExpense.component.html'
})
export class AddExpenseComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }
    public mode: string;

    @Input() expenseData: ExpenseModal[] = [];
    @Input() expenseRow: ExpenseModal[] = [];
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('hvPetrol') hvPetrolRef: ElementRef;
    @ViewChild('soaPetrol') soaPetrolRef: ElementRef;

    hvClientCtrl: FormControl;
    hvRefCtrl: FormControl;
    soaClientCtrl: FormControl;
    soaRefCtrl: FormControl;
    recheckupClientCtrl: FormControl;

    isLoading: boolean = false;
    columns = [];

    hvClientList: any[] = [];
    soaClientList: any[] = [];
    recheckupClientList: any[] = [];
    refList: any[] = [];
    doctorRefList: any[] = [];
    filteredHvReference: Observable<any[]>;
    filteredSoaReference: Observable<any[]>;

    private hvSearch = new Subject<string>();
    private soaSearch = new Subject<string>();
    private recheckupSearch = new Subject<string>();

    hvRow: any = this.emptyRow('HV');
    soaRow: any = this.emptyRow('SOA');
    recheckupRow: any = this.emptyRow('Recheckup');

    clients: any[] = [];
    actualTotalAmount: number = 0;

    constructor(
        public store: Store<fromRootStore.State>,
        private modalService: BsModalService,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private expenseService: ExpenseService,
        public subscribeService: SubscribeService
    ) {}

    reorderable: boolean = true;

    page = {
        limit: 50,
        count: 0,
        offset: 0,
        orderBy: 'expense_id',
        orderDir: 'asc'
    };

    ngOnInit(): void {
        let that = this;
        if (this._params['mode'] == 'Add') {
            this.expenseData['date'] = new Date();
            this.getAutoNumber();
        }

        this.hvClientCtrl        = new FormControl('');
        this.hvRefCtrl           = new FormControl('');
        this.soaClientCtrl       = new FormControl('');
        this.recheckupClientCtrl = new FormControl('');
        this.soaRefCtrl          = new FormControl('');

        this.filteredHvReference = this.hvRefCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterDoctorRef(name) : this.doctorRefList.slice());

        this.filteredSoaReference = this.soaRefCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterDoctorRef(name) : this.doctorRefList.slice());

        this.store.select(fromCommonStore.getAllReference).subscribe((res: any) => {
            if (!_.isEmpty(res)) {
                that.refList = res;
                that.doctorRefList = res.filter((r: any) => r.source === 'DOCTOR');
            }
        });

        this.columns = [
            { name: 'SNo',          prop: 'sno',           width: 55,  minWidth: 55,  maxWidth: 55,  sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Visit Type',   prop: 'visit_type',    width: 80,  minWidth: 80,  cellClass: 'wrap-text' },
            { name: 'Status',       prop: 'hv_sub_type',   width: 120, minWidth: 120, cellClass: 'wrap-text' },
            { name: 'Reference',    prop: 'reference_name', width: 150, minWidth: 100, cellClass: 'wrap-text' },
            { name: 'Client ID',    prop: 'client_no',     width: 100, minWidth: 100, cellClass: 'wrap-text' },
            { name: 'Client Name',  prop: 'client_name',   width: 150, minWidth: 150, cellClass: 'wrap-text' },
            { name: 'Petrol',       prop: 'petrol_amount', width: 70,  minWidth: 70,  cellClass: 'wrap-text' },
            { name: 'Food',         prop: 'food_amount',   width: 70,  minWidth: 70,  cellClass: 'wrap-text' },
            { name: 'Bus',          prop: 'bus_amount',    width: 70,  minWidth: 70,  cellClass: 'wrap-text' },
            { name: 'Auto',         prop: 'auto_amount',   width: 70,  minWidth: 70,  cellClass: 'wrap-text' },
            { name: 'Tea',          prop: 'tea_amount',    width: 70,  minWidth: 70,  cellClass: 'wrap-text' },
            { name: 'Total',        prop: 'total_amount',  width: 80,  minWidth: 80,  cellClass: 'wrap-text' },
            { name: 'Place/Pincode',prop: 'place_pincode', width: 130, minWidth: 130, cellClass: 'wrap-text' },
            { name: 'Action',       prop: 'action',        width: 70,  minWidth: 70,  maxWidth: 70,  sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.hvSearch
            .debounceTime(300).distinctUntilChanged()
            .switchMap(term => term ? this.commonService.loadClientList(term, 'expenseEntry') : Observable.of<any[]>([]))
            .catch(e => Observable.of<any[]>([]))
            .subscribe(res => { that.hvClientList = res; });

        this.soaSearch
            .debounceTime(300).distinctUntilChanged()
            .switchMap(term => term ? this.commonService.loadClientList(term, 'expenseEntry') : Observable.of<any[]>([]))
            .catch(e => Observable.of<any[]>([]))
            .subscribe(res => { that.soaClientList = res; });

        this.recheckupSearch
            .debounceTime(300).distinctUntilChanged()
            .switchMap(term => term ? this.commonService.loadClientList(term, 'expenseEntry') : Observable.of<any[]>([]))
            .catch(e => Observable.of<any[]>([]))
            .subscribe(res => { that.recheckupClientList = res; });
    }

    filterRef(name: any) {
        if (typeof name !== 'string') return this.refList.slice();
        return this.refList.filter(r => r.name.toLowerCase().includes(name.toLowerCase()));
    }

    filterDoctorRef(name: any) {
        if (typeof name !== 'string') return this.doctorRefList.slice();
        return this.doctorRefList.filter(r => r.name.toLowerCase().includes(name.toLowerCase()));
    }

    displayRefFn(ref_id: any) {
        if (!ref_id || !this.refList.length) return '';
        let found = this.refList.find(r => r.ref_id == ref_id);
        return found ? found.name : '';
    }

    onHvRefSelect(ref: any) {
        this.hvRow.ref_id   = ref.ref_id;
        this.hvRow.ref_name = ref.name;
    }

    onSoaRefSelect(ref: any) {
        this.soaRow.ref_id   = ref.ref_id;
        this.soaRow.ref_name = ref.name;
    }

    emptyRow(visitType: string) {
        return {
            enabled: false,
            visit_type: visitType,
            hv_sub_type: '',
            ref_id: null,
            ref_name: '',
            client_id: null,
            client_no: '',
            client_name: '',
            client_search: '',
            petrol_amount: null,
            food_amount: null,
            bus_amount: null,
            auto_amount: null,
            tea_amount: null,
            total_amount: 0,
            place_pincode: ''
        };
    }

    getAutoNumber() {
        let that = this,
            expenseDate = moment(this.expenseData['date']).format('YYYY-MM-DD'),
            params = { account_type: 'expense', date: expenseDate };
        this.commonService.getAutoNumber(params)
            .then(function (res: any) {
                that.expenseData['expense_no'] = res['auto_no'];
            });
    }

    setPageData(): void {
        let that = this;
        if (that._params != undefined) {
            that.expenseData = Object.assign({}, that._params);
            that.mode = that._params['mode'];
            that.expenseData['btnTxt'] = that._params['btnTxt'];
            if (that.mode != 'Add') {
                that.expenseData['date'] = new Date(that._params['expense_date']);
                that.getEditExpenseDetails(that.expenseData);
            } else {
                this.clients = [];
                this.actualTotalAmount = 0;
                this.hvRow = this.emptyRow('HV');
                this.soaRow = this.emptyRow('SOA');
                this.recheckupRow = this.emptyRow('Recheckup');
            }
        }
    }

    searchClient(query: string, type: string) {
        if (type === 'hv')         { this.hvSearch.next(query); }
        else if (type === 'soa')   { this.soaSearch.next(query); }
        else                        { this.recheckupSearch.next(query); }
    }

    displayClientFn(client_id: any) {
        return '';
    }

    onRowClientSelect(client: any, type: string) {
        if (type === 'hv') {
            this.hvRow.client_id     = client.client_id;
            this.hvRow.client_no     = client.client_no;
            this.hvRow.client_name   = client.client_name;
            this.hvRow.branch_name   = client.branch_name || '';
            if (client.reference) {
                this.hvRow.ref_id   = client.reference;
                this.hvRow.ref_name = client.reference_name || '';
                this.hvRefCtrl.setValue(client.reference);
            }
            setTimeout(() => { if (this.hvPetrolRef) this.hvPetrolRef.nativeElement.focus(); }, 100);
        } else if (type === 'soa') {
            this.soaRow.client_id     = client.client_id;
            this.soaRow.client_no     = client.client_no;
            this.soaRow.client_name   = client.client_name;
            this.soaRow.branch_name   = client.branch_name || '';
            if (client.reference) {
                this.soaRow.ref_id   = client.reference;
                this.soaRow.ref_name = client.reference_name || '';
                this.soaRefCtrl.setValue(client.reference);
            }
            setTimeout(() => { if (this.soaPetrolRef) this.soaPetrolRef.nativeElement.focus(); }, 100);
        } else {
            this.recheckupRow.client_id     = client.client_id;
            this.recheckupRow.client_no     = client.client_no;
            this.recheckupRow.client_name   = client.client_name;
            this.recheckupRow.branch_name   = client.branch_name || '';
        }
    }

    calculateRowTotal(type: string) {
        let row = type === 'hv' ? this.hvRow : type === 'soa' ? this.soaRow : this.recheckupRow;
        row.total_amount = (
            this.toNum(row.petrol_amount) +
            this.toNum(row.food_amount) +
            this.toNum(row.bus_amount) +
            this.toNum(row.auto_amount) +
            this.toNum(row.tea_amount)
        );
    }

    toNum(val: any): number {
        return val ? parseFloat(val) : 0;
    }

    addRowToGrid(type: string) {
        let row = type === 'hv' ? this.hvRow : type === 'soa' ? this.soaRow : this.recheckupRow;
        let toast = { type: 'warning', title: 'WARNING' };

        if (!row.client_id) {
            toast['body'] = 'Please Select Client ID';
            this.toasterService.pop(toast);
            return;
        }

        if (!row.ref_id) {
            toast['body'] = 'Please Select Reference';
            this.toasterService.pop(toast);
            return;
        }

        if (!row.place_pincode) {
            toast['body'] = 'Please Enter Place & Pincode';
            this.toasterService.pop(toast);
            return;
        }

        let entry = {
            client_id:      row.client_id,
            client_no:      row.client_no,
            client_name:    row.client_name,
            branch_name:    row.branch_name || '',
            visit_type:     row.visit_type,
            hv_sub_type:    row.hv_sub_type || '',
            ref_id:         row.ref_id || null,
            reference_name: row.ref_name || '',
            petrol_amount:  row.petrol_amount || 0,
            food_amount:    row.food_amount   || 0,
            bus_amount:     row.bus_amount    || 0,
            auto_amount:    row.auto_amount   || 0,
            tea_amount:     row.tea_amount    || 0,
            total_amount:   row.total_amount  || 0,
            place_pincode:  row.place_pincode || ''
        };

        this.clients.push(entry);
        this.calculateActualTotal();

        if (type === 'hv')         {
            this.hvRow = this.emptyRow('HV');
            this.hvRefCtrl.setValue('');
        }
        else if (type === 'soa')   {
            this.soaRow = this.emptyRow('SOA');
            this.soaRefCtrl.setValue('');
        }
        else                        { this.recheckupRow   = this.emptyRow('Recheckup'); }
    }

    calculateActualTotal() {
        this.actualTotalAmount = this.clients.reduce((sum, c) => sum + this.toNum(c.total_amount), 0);
    }

    deleteClient(row: any): void {
        this.clients.splice(this.clients.indexOf(row), 1);
        this.calculateActualTotal();
    }

    getEditExpenseDetails(data: any): void {
        let that = this;
        this.expenseService
            .getExpenseDetails({ expense_id: data.expense_id })
            .then(function (res: any) {
                if (res && res.data) {
                    that.clients = res.data;
                    that.calculateActualTotal();
                }
            });
    }

    onResetExpense(): void {
        if (this._params['mode'] == 'Add') {
            this.expenseData = [];
            this.expenseData['date'] = new Date();
            this.clients = [];
            this.actualTotalAmount = 0;
            this.hvRow         = this.emptyRow('HV');
            this.soaRow        = this.emptyRow('SOA');
            this.recheckupRow  = this.emptyRow('Recheckup');
            this.hvRefCtrl.setValue('');
            this.soaRefCtrl.setValue('');
        }
    }

    onBackToList(): void {
        this.subscribeService.subReloadExpenseGrid();
        this.subscribeService.subScribeDeleteActiveTab();
    }

    onSaveExpense() {
        let toast = { type: 'warning', title: 'WARNING' };
        if (this.clients.length == 0) {
            swal('ERROR', 'Please Add Atleast One Client Details', 'error');
            return false;
        }
        if (this.actualTotalAmount == 0) {
            swal('ERROR', 'Actual Total Amount cannot be 0', 'error');
            return false;
        }
        let that = this;
        let expenseDet = that.expenseData;
        let expenseDate = moment(expenseDet['date']).format('YYYY-MM-DD');

        let params: any = {
            expense_date:  expenseDate,
            total_amount:  this.actualTotalAmount,
            comments:      expenseDet['comments'] ? expenseDet['comments'] : '',
            clients:       JSON.stringify(this.clients)
        };

        if (expenseDet['btnTxt'] == 'Save') {
            params['expense_no'] = expenseDet['expense_no'];
            params['mode'] = 'Add';
            this.isLoading = true;
            this.expenseService.addExpense(params)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');
                        that.clients = [];
                        that.expenseData = [];
                        that.actualTotalAmount = 0;
                        that.subscribeService.subReloadExpenseGrid();
                        that.subscribeService.subScribeDeleteActiveTab();
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                });
        } else {
            params['expense_id'] = expenseDet['expense_id'];
            params['mode'] = 'Update';
            this.isLoading = true;
            this.expenseService.UpdateExpense(params)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');
                        that.subscribeService.subReloadExpenseGrid();
                        that.subscribeService.subScribeDeleteActiveTab();
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                });
        }
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/expense/addExpense.component.ts